import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { GIButton, Modal } from 'app-components';

import { configs } from '@constants/configs/configs';
import { StatusType } from '../types/selfDesignationOtpTypes';
import { environmentSelector } from '@selectors/commonSelectors';
import { useAppSelector } from '@hooks/index';
import useSelfDesignationOtpRole from '../hooks/useSelfDesignationOtpRole';

export default function SelfDesignationOtpErrorModal(props) {
    const {
        actions: { hideModal },
        modal: {
            modalData: { selfDesignationOtpErrorType },
        },
        modalHeaderProps: {
            modalId
        }
    } = props;

    const { role } = useSelfDesignationOtpRole();

    const navigate = useNavigate();

    const onCloseModal = () => {
        hideModal();
        navigate(configs.routes.EDE_ID_PROOFING);
    };

    const modalHeaderMessage = () => {
        switch (selfDesignationOtpErrorType) {
            case StatusType.MAX_ATTEMPT:
                return `selfDesignation.${role}.search.searchResult.modal.otp.expiry.maxlimit.header`;
            case StatusType.MAX_TIME:
                return `selfDesignation.${role}.search.searchResult.modal.otp.expiry.timelimit.header`;
            case StatusType.CAN_NOT_GENERATE_OTP:
                return `selfDesignation.${role}.search.searchResult.modal.otp.canNotGenerateOtp.header`;
            default:
                return 'common.status.error_in_processing';
        }
    };

    const renderErrorMessage = () => {
        const supportCenterNumber = useAppSelector(environmentSelector).links.BROKER_PHONE;
        switch (selfDesignationOtpErrorType) {
            case StatusType.MAX_ATTEMPT:
                return (
                    <>
                        <p>
                            <FormattedMessage id={`selfDesignation.${role}.search.searchResult.modal.otp.expiry.maxlimit`} />
                        </p>
                        <p>
                            <FormattedMessage
                                id={`selfDesignation.${role}.search.searchResult.modal.otp.expiry.contactSupport`}
                                values={{ supportCenterNumber }}
                            />
                        </p>
                    </>
                );
            case StatusType.MAX_TIME:
                return (
                    <>
                        <p>
                            <FormattedMessage id={`selfDesignation.${role}.search.searchResult.modal.otp.expiry.timelimit`} />
                        </p>
                        <p>
                            <FormattedMessage id={`selfDesignation.${role}.search.searchResult.modal.otp.expiry.initiateNewOtp`} />
                        </p>
                    </>
                );
            case StatusType.CAN_NOT_GENERATE_OTP:
                return (
                    <>
                        <p>
                            <FormattedMessage id={`selfDesignation.${role}.search.searchResult.modal.otp.canNotGenerateOtp.content1`} />
                        </p>
                        <p>
                            <FormattedMessage
                                id={`selfDesignation.${role}.search.searchResult.modal.otp.canNotGenerateOtp.content2`}
                                values={{ supportCenterNumber }}
                            />
                        </p>
                    </>
                );
            default:
                return (
                    <p>
                        <FormattedMessage id={`selfDesignation.${role}.search.searchResult.modal.otp.expiry.failure`} />
                    </p>
                );
        }
    };

    return (
        <Modal id="self-designation-otp-modal">
            <Modal.Header id="self-designation-otp-modal-header" titleId={modalHeaderMessage()} onHide={onCloseModal} />
            <Modal.Body id="self-designation-otp-modal-body">{renderErrorMessage()}</Modal.Body>
            <Modal.Controls>
                <GIButton
                    id={`${modalId}-modalCloseButton`}
                    labelId="button.close"
                    variant="secondary"
                    onClickHandler={onCloseModal}
                />
            </Modal.Controls>
        </Modal>
    );
}
